import { Link } from 'react-router-dom';

function Confirmation() {
    return (
        <div>
            I am Confirmation component.
            <Link to="/signup">make an account &rarr;</Link>
        </div>
    );
}

export default Confirmation;
